import './FindPw_update.scss';
import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import TermsAgreement from './TermsAgreement'; // 이용약관 컴포넌트 임포트
import fnc from '../mymod/commFunction';
import * as S from '../scss/theme';
import TermsAgreementInfo from './TermsAgreementInfo';

function FindPw_update() {
  const svrUrl = process.env.REACT_APP_SERVER_URL;
  const navigate = useNavigate();

  const id = fnc.getCookie_public('id_find');
  const stCode = fnc.getCookie_public('stCode_find');
  const userName = fnc.getCookie_public('userName_find');


  const [userInput, setUserInput] = useState({
    password: '',
    confirmPassword: '',
  });


  // 오류 메시지를 관리할 상태 추가
  const [errorMessages, setErrorMessages] = useState({});

  // 입력 필드가 변경될 때마다 호출될 함수
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserInput({
      ...userInput,
      [name]: value,
    });
  };


  const validateForm = () => {
    let errors = {};
    let formIsValid = true;
   
    // 새 비밀번호 검사
    if (!userInput.password) {
      errors.password = '새 비밀번호를 입력해 주세요.';
      formIsValid = false;
    } else if (userInput.password.length < 6) {
      errors.password = '새 비밀번호는 최소 6자 이상이어야 합니다.';
      formIsValid = false;
    }

    // 비밀번호 확인 검사
    if (userInput.password !== userInput.confirmPassword) {
      errors.confirmPassword = '새 비밀번호가 서로 일치하지 않습니다.';
      formIsValid = false;
    }


    setErrorMessages(errors);
    return formIsValid;
  };

  // 폼 제출 시 호출될 함수
  const handleSubmit = (e) => {
    e.preventDefault(); // 폼 제출 기본 이벤트 방지

    if (validateForm()) {

      const rtn = window.confirm('비밀번호를 수정하시겠습니까?');
      if(rtn) {
     
        fncUpdatePw(stCode, userInput.confirmPassword);
      }
   
    } else {
      console.log('Validation Failed:', errorMessages);
      // 유효성 검사 실패 처리 로직 추가 (예: 오류 메시지 표시)
    }
  };


  function onClose() {
    navigate(-1); 
    // navigate('/login'); 
  }
//---------------------------------------------------axios
  

function fncUpdatePw(stCode, newPw) {   

    fnc.sendAxios('/kuesb/updatePw', {stCode, pw: newPw }, (res) => {
      if (res) {      

        if (res.success === true) {
          // fncInsertUserAgreements(stCode);
          alert('비밀번호 수정이 완료되었습니다. \n 로그인 하세요!');
          navigate('/login'); 
        }else if (res.success === true) {
            alert('실패했습니다!');

        }
       
      } else {
        alert('실패했습니다.');
      }
    });
  }


  
function fncInsertUserAgreements(stCode) {   
    fnc.sendAxios('/aca/insertUserAgreements', {stCode}, (res) => {
      if (res) {      
     
      } else {
        console.log("속성이 obj 내에 없습니다.");
      }
    });
  }



//==================================================
  return (
    <S.Section2>
    <div className='FindPw_update'>
      <div className='wrap-main'>

      <form onSubmit={handleSubmit}>
      <p className='title'>비밀번호 변경</p>
      
      <div className='wrap-main2'>    

        <section className='section-input'>           

          <div>
              <label>*성명</label>
              <p className='userName'>{userName}</p>
          </div>
          
          <div>
              <label htmlFor="password">*새 비밀번호</label>
              <input
                type="password"
                id="password"
                name="password"
                value={userInput.password}
                onChange={handleChange}
                required
                placeholder='새 비밀번호를 입력해 주세요.'
              />
              {errorMessages.password && <p className="errorMessage">{errorMessages.password}</p>}
          </div>

          <div>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                value={userInput.confirmPassword}
                onChange={handleChange}
                required
                placeholder='새 비밀번호를 한번 더 입력해 주세요.'
              />
              {errorMessages.confirmPassword && <p className="errorMessage"> {errorMessages.confirmPassword}</p>}
          </div>
        </section>


        <section className='section-termsAgreementInfo'>
            <TermsAgreementInfo/>
        </section>


          {/* 메뉴버튼 */}
          <section className='section-menu'>
              <Button  className='btnClose h-btn-gray' onClick={onClose} >취소</Button>
              <Button type='submit' className='btnSave h-btn-red' >확인</Button>
          </section>


      </div>

    </form>
    </div>
    </div>
   </S.Section2>
  );
}

export default FindPw_update;
